import {
    isShelf,
    getCubeIndex,
    isPartition,
    isTextarea,
    isBafflePlate,
    isGoods,
    isInStage,
    isInShelf,
    isInLayer
} from './cubeInfo';
import { findParentIdByCubeId, findChildCubeIds } from './baseQuery';
import { findCubeLayer } from './advanceQuery';

function sortByCubeIndex(cubeIds: CubeId[]): CubeId[] {
    let result: CubeId[] = [];
    let stageCubes: CubeId[] = sortStageCube(cubeIds);
    let stageLayerCube: CubeId[] = sortStageLayerCube(cubeIds);
    let layers: CubeId[] = sortLayers(cubeIds);
    let layerCubes: CubeId[] = sortShelfLayerCubes(cubeIds);

    result = result.concat(stageCubes);
    result = result.concat(stageLayerCube);
    result = result.concat(layers);
    result = result.concat(layerCubes);

    return result;
}

function sortStageLayerCube(cubeIds: CubeId[]): CubeId[] {
    let result: CubeId[] = [];
    let layers: Map<CubeId, CubeId[]> = new Map();
    let layerSort: CubeId[] = [];

    cubeIds.forEach((cubeId: CubeId): void => {
        if (!isInLayer(cubeId)) {
            return;
        }

        let itsLayer: CubeId = findCubeLayer(cubeId);

        if (!isInStage(itsLayer)) {
            return;
        }

        if (isGoods(cubeId)
            || isTextarea(cubeId)
            || isBafflePlate(cubeId)) {
            let layer: CubeId = findParentIdByCubeId(cubeId);

            if (!layers.has(layer)) {
                layers.set(layer, [cubeId]);
                return;
            }

            layers.get(layer).push(cubeId);
        }
    });

    layerSort = sortCubes(Array.from(layers.keys()));
    layerSort.forEach((layer: CubeId) => {
        layers.set(layer, sortCubes(layers.get(layer)));
        result = result.concat(layers.get(layer));
    });

    return result;
}

function sortShelfLayerCubes(cubeIds: CubeId[]): CubeId[] {
    let result: CubeId[] = [];
    let layers: Map<CubeId, CubeId[]> = new Map();
    let layerSort: CubeId[] = [];

    cubeIds.forEach((cubeId: CubeId): void => {
        if (!isInLayer(cubeId)) {
            return;
        }

        let itsLayer: CubeId = findCubeLayer(cubeId);

        if (!isInShelf(itsLayer)) {
            return;
        }

        if (isGoods(cubeId)
            || isTextarea(cubeId)
            || isBafflePlate(cubeId)) {
            let layer: CubeId = findParentIdByCubeId(cubeId);

            if (!layers.has(layer)) {
                layers.set(layer, [cubeId]);
                return;
            }

            layers.get(layer).push(cubeId);
        }
    });
    layerSort = sortLayers(Array.from(layers.keys()));
    layerSort.forEach((layer: CubeId) => {
        layers.set(layer, sortCubes(layers.get(layer)));
        result = result.concat(layers.get(layer));
    });

    return result;
}

function sortLayers(cubeIds: CubeId[]): CubeId[] {
    let result: CubeId[] = [];
    let layers: CubeId[] = [];
    let shelfs: Map<CubeId, CubeId[]> = new Map();

    cubeIds.forEach((cubeId: CubeId): void => {
        if (isPartition(cubeId) && isInShelf(cubeId)) {
            layers.push(cubeId);
        }
    });
    layers.forEach((cubeId: CubeId): void => {
        let shelf: CubeId = findParentIdByCubeId(cubeId);

        if (!shelfs.has(shelf)) {
            shelfs.set(shelf, [cubeId]);
            return;
        }
        shelfs.get(shelf).push(cubeId);
    });

    let shelfsSort: CubeId[] = sortCubes(Array.from(shelfs.keys()));

    shelfsSort.forEach((shelf: CubeId): void => {
        let layersSort: CubeId[] = sortCubes(shelfs.get(shelf));

        result = result.concat(layersSort);
    });

    return result;
}

function clearEmpty(cubeIds: CubeId[]): CubeId[] {
    return cubeIds.filter((cubeId: CubeId): boolean => {
        return !!cubeId;
    });
}

function sortStageCube(cubeIds: CubeId[]): CubeId[] {
    let stageCubes: CubeId[] = [];

    cubeIds.forEach((cubeId: CubeId): void => {
        if (isInStage(cubeId)) {
            stageCubes.push(cubeId);
        }
    });

    return sortCubes(stageCubes);
}

function sortCubes(cubeIds: CubeId[]): CubeId[] {
    let result: CubeId[] = [];

    cubeIds.forEach((cubeId: CubeId): void => {
        let index: number = getCubeIndex(cubeId);

        result[index] = cubeId;
    });
    result = clearEmpty(result);
    result.reverse();

    return result;
}

export {
    sortByCubeIndex
};
